import React from "react";
import { Table } from "tea-component";
import { BasicTableType } from "./type";
const { scrollable } = Table.addons;

const basicAddons:Array<any> = [
  scrollable({
    maxHeight: '100%',
    minWidth: '100%',
    onScrollBottom: () => console.log("到达底部"),
  })
];

const  BasicTable = (props:BasicTableType) => {
  const {columns, records,addonsConfig, ...reset} = props;
  return (
    <Table
      records={records || []}
      columns={columns || []}
      addons={addonsConfig ? addonsConfig : basicAddons}
      bordered={'all'}
      {...reset}
    />
  );
};

export default BasicTable;